import React from "react";
import { CheckCircle2, CircleAlert, XCircle, Lightbulb, Check, X } from "lucide-react";

const STATUS_STYLES = {
  correct: {
    Icon: CheckCircle2,
    title: "Bravo !",
    color: "#2563eb",
    background: "#eff6ff",
  },
  partial: {
    Icon: CircleAlert,
    title: "Presque !",
    color: "#d97706",
    background: "#fffbeb",
  },
  incorrect: {
    Icon: XCircle,
    title: "Ce n'est pas ça",
    color: "#dc2626",
    background: "#fef2f2",
  },
};

const Section = ({ title, children }) => (
  <div style={{ marginTop: 14 }}>
    <p style={{ fontWeight: 700, marginBottom: 6 }}>{title}</p>
    {children}
  </div>
);

const CorrectionFeedbackModal = ({ evaluation, onContinue }) => {
  if (!evaluation) return null;

  const style = STATUS_STYLES[evaluation.status] || STATUS_STYLES.incorrect;
  const { Icon } = style;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 480,
          maxHeight: "90dvh",
          overflowY: "auto",
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: 12,
            borderRadius: 12,
            background: style.background,
            color: style.color,
          }}
        >
          <Icon size={36} />
          <div>
            <p style={{ fontWeight: 700, fontSize: 18 }}>{style.title}</p>
            {evaluation.summary && <p style={{ color: "#374151" }}>{evaluation.summary}</p>}
          </div>
        </div>

        {evaluation.correct_points?.length > 0 && (
          <Section title="Ce que tu as bien fait">
            {evaluation.correct_points.map((point, i) => (
              <p key={i} style={{ display: "flex", gap: 8, color: "#2563eb" }}>
                <Check size={18} style={{ flexShrink: 0, marginTop: 2 }} />
                <span style={{ color: "#374151" }}>{point}</span>
              </p>
            ))}
          </Section>
        )}

        {evaluation.mistakes?.length > 0 && (
          <Section title="Ce qu'il faut corriger">
            {evaluation.mistakes.map((mistake, i) => (
              <p key={i} style={{ display: "flex", gap: 8, color: "#dc2626" }}>
                <X size={18} style={{ flexShrink: 0, marginTop: 2 }} />
                <span style={{ color: "#374151" }}>{mistake}</span>
              </p>
            ))}
          </Section>
        )}

        {evaluation.status !== "correct" && evaluation.correct_solution && (
          <Section title="La bonne réponse">
            <p style={{ color: "#374151" }}>{evaluation.correct_solution}</p>
          </Section>
        )}

        {evaluation.recommendations?.length > 0 && (
          <Section title="Mes conseils">
            {evaluation.recommendations.map((tip, i) => (
              <p key={i} style={{ display: "flex", gap: 8, color: "#2563eb" }}>
                <Lightbulb size={18} style={{ flexShrink: 0, marginTop: 2 }} />
                <span style={{ color: "#374151" }}>{tip}</span>
              </p>
            ))}
          </Section>
        )}

        {evaluation.encouragement && (
          <p style={{ marginTop: 14, fontStyle: "italic", color: "#374151" }}>
            {evaluation.encouragement}
          </p>
        )}

        <button
          type="button"
          onClick={onContinue}
          style={{
            marginTop: 18,
            width: "100%",
            padding: "12px 0",
            borderRadius: 12,
            border: "none",
            background: style.color,
            color: "#fff",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          Continuer
        </button>
      </div>
    </div>
  );
};

export default CorrectionFeedbackModal;
